import axios from "axios";
import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
// import Skeleton from "react-loading-skeleton";
import { useParams } from "react-router-dom";
import PageLoader from "../../components/global/loader/PageLoader";
// import ContactForm from "../../components/contact/ContactForm";
// import PostRemoveForm from "../../components/contact/PostRemovalForm";
import { InternalBanner } from "../../components/internals/InternalBanner";
import './styles.scss';

export const Default = ({
    parent_slug
}) => {
    const { slug } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);
    useEffect(() => {
        document.title = "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
        fetchPageContet(slug);
    }, [slug]);

    
    const fetchPageContet = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(
                parent_slug ? `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${parent_slug}/${slug}` :   `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${slug}`);
            console.log(data)
            if (data?.page) {
                if (data?.yoast_title?.length > 0) {
                    document.title = data?.yoast_title;
                } else {
                    document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
                }
                
                if (document.querySelector('#wp-admin-bar-edit a')) {
                    document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                    document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
                }
            }

            setPageContent(data?.page ?? null);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    return <Fade delay={1}>
        <main id='main' className="internal-page">
            {
                !isFetching && <>    
                    <InternalBanner page={pageContent} />
                    <section id="main-article-content">               
                        <div className="container">
                            <article dangerouslySetInnerHTML={{__html: pageContent?.post_content }}></article>
                        </div>
                    </section>
                </>
            }

            {
                isFetching && <PageLoader />
            }
        </main>
    </Fade>
}

export default Default;